(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[48],{

/***/ 12453:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var getGAUserID = function getGAUserID() {
  try {
    var trackers = ga.getAll();
    var i, len;

    for (i = 0, len = trackers.length; i < len; i += 1) {
      if (trackers[i].get("trackingId") === "UA-186465270-2") {
        return trackers[i].get("clientId");
      }
    }
  } catch (e) {}

  return false;
};

/* harmony default export */ __webpack_exports__["Z"] = (getGAUserID);

/***/ }),

/***/ 92559:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30266);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);



var sendData = /*#__PURE__*/function () {
  var _ref2 = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)( /*#__PURE__*/_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(_ref) {
    var api, data, token, endpoint, headers, options, response;
    return _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            api = _ref.api, data = _ref.data, token = _ref.token;
            endpoint = api;
            headers = {
              "Content-Type": "application/json",
              "captcha-response": token
            };
            options = {
              method: "POST",
              headers: headers,
              body: JSON.stringify(data)
            };
            _context.next = 6;
            return fetch(endpoint, options);

          case 6:
            response = _context.sent;
            _context.next = 9;
            return response.json();

          case 9:
            return _context.abrupt("return", _context.sent);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function sendData(_x) {
    return _ref2.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["Z"] = (sendData);

/***/ }),

/***/ 77450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SCREEN */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var SCREEN = {
  DESKTOP: "DESKTOP",
  TABLET: "TABLET",
  MOBILE: "MOBILE"
};

var useResizeScreenModified = function useResizeScreenModified(handler) {
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (true) {
      var _window3;

      var handleScreen = function handleScreen() {
        var _window;

        if ((_window = window) !== null && _window !== void 0 && _window.innerWidth) {
          var _window2;

          if (((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.innerWidth) <= 1023) {
            try {
              handler(SCREEN.TABLET);
            } catch (error) {
              console.error();
            }
          } else {
            try {
              handler(SCREEN.DESKTOP);
            } catch (error) {
              console.error();
            }
          }
        }
      };

      handleScreen();
      (_window3 = window) === null || _window3 === void 0 ? void 0 : _window3.addEventListener("resize", handleScreen);
      return function () {
        var _window4;

        /* Clean up function. Remove event before component unmount. */
        (_window4 = window) === null || _window4 === void 0 ? void 0 : _window4.removeEventListener("resize", handleScreen);
      };
    }
  }, []);
};

/* harmony default export */ __webpack_exports__["Z"] = (useResizeScreenModified);

/***/ }),

/***/ 62951:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ trigger; }
/* harmony export */ });
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function trigger(eventType, data, fullName) {
  var event = new CustomEvent(eventType, {
    detail: {
      dataForm: _objectSpread({
        fullname: fullName,
        email: data.email
      }, data),
      response: data
    }
  });

  try {
    document.dispatchEvent(event);
  } catch (error) {
    console.log(error);
  }
}

/***/ }),

/***/ 7778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ BiLoaderAlt; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function BiLoaderAlt(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M12 22c5.421 0 10-4.579 10-10h-2c0 4.337-3.663 8-8 8s-8-3.663-8-8c0-4.336 3.663-8 8-8V2C6.579 2 2 6.58 2 12c0 5.421 4.579 10 10 10z"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 66865:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j7": function() { return /* binding */ InputEmail; },
/* harmony export */   "oH": function() { return /* binding */ InputText; },
/* harmony export */   "Z6": function() { return /* binding */ InputPhone; },
/* harmony export */   "Jg": function() { return /* binding */ CheckBox; }
/* harmony export */ });
/* unused harmony export InputNumber */
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91164);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


var _excluded = ["name", "placeholder", "register", "errors", "requiredText"],
    _excluded2 = ["as", "name", "placeholder", "register", "errors", "requiredText"],
    _excluded3 = ["name", "placeholder", "register", "errors", "requiredText", "invalidText"],
    _excluded4 = ["name", "text", "register", "errors", "checkboxTextClassName"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var InputEmail = function InputEmail(_ref) {
  var _errors$name, _errors$email;

  var name = _ref.name,
      placeholder = _ref.placeholder,
      register = _ref.register,
      errors = _ref.errors,
      requiredText = _ref.requiredText,
      props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", _objectSpread(_objectSpread({
      type: "email"
    }, register(name ? name : "email", {
      required: {
        value: true,
        message: requiredText || "Email is required"
      },
      pattern: {
        // Value: /(^(?:[0-9]+[a-z]|[a-z]+[0-9]|[a-z])[a-z0-9._%+-]*)+@[a-z0-9.-]+\.[a-z]{2,}$/,
        value: /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/,
        message: "Invalid e-mail"
      }
    })), {}, {
      placeholder: placeholder || "Email*",
      pattern: "[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$",
      className: "w-full border-0 border-b border-b-gray-300 p-2 text-bbc-gray placeholder-gray-300 focus:ring-0 ",
      autoComplete: "off"
    }, props)), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
      className: "inline-block pt-2 text-left text-sm text-red-500",
      children: name ? (_errors$name = errors[name]) === null || _errors$name === void 0 ? void 0 : _errors$name.message : (_errors$email = errors.email) === null || _errors$email === void 0 ? void 0 : _errors$email.message
    })]
  });
}; // Text Field must be single word or multiple word space with "_"

var InputText = function InputText(_ref2) {
  var _errors$name2;

  var as = _ref2.as,
      name = _ref2.name,
      placeholder = _ref2.placeholder,
      register = _ref2.register,
      errors = _ref2.errors,
      requiredText = _ref2.requiredText,
      props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref2, _excluded2);

  var CustomTag = as || "input";
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(CustomTag, _objectSpread(_objectSpread({
      type: "text"
    }, register(name, {
      required: {
        value: true,
        message: requiredText || "This field is required"
      }
    })), {}, {
      placeholder: placeholder,
      className: "invalid-textfield w-full border-0 border-b border-b-gray-300 p-2 text-bbc-gray placeholder-gray-300 focus:ring-0",
      autoComplete: "off"
    }, props)), errors[name] && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
      className: "inline-block pt-2 text-sm text-red-500",
      children: (_errors$name2 = errors[name]) === null || _errors$name2 === void 0 ? void 0 : _errors$name2.message
    })]
  });
};
var InputPhone = function InputPhone(_ref3) {
  var _errors$name3, _errors$phone_number;

  var name = _ref3.name,
      placeholder = _ref3.placeholder,
      register = _ref3.register,
      errors = _ref3.errors,
      requiredText = _ref3.requiredText,
      invalidText = _ref3.invalidText,
      props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref3, _excluded3);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", _objectSpread(_objectSpread({
      type: "text"
    }, register(name || "phone_number", {
      required: {
        value: true,
        message: requiredText || "Phone number is required"
      },
      pattern: {
        value: /[0-9]+/,
        message: invalidText || "Invalid phone number"
      }
    })), {}, {
      placeholder: placeholder,
      pattern: "[0-9]+",
      className: "invalid-textfield w-full border-0 border-b border-b-gray-300 p-2 text-bbc-gray placeholder-gray-300 focus:ring-0",
      autoComplete: "off"
    }, props)), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
      className: "inline-block pt-2 text-sm text-red-500",
      children: name ? (_errors$name3 = errors[name]) === null || _errors$name3 === void 0 ? void 0 : _errors$name3.message : (_errors$phone_number = errors.phone_number) === null || _errors$phone_number === void 0 ? void 0 : _errors$phone_number.message
    })]
  });
};
var InputNumber = function InputNumber(_ref4) {
  var numberValue = _ref4.numberValue,
      min = _ref4.min,
      max = _ref4.max,
      setNumberValue = _ref4.setNumberValue;

  var handleOnclickNumber = function handleOnclickNumber(number) {
    setNumberValue(number);
  };

  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      className: "relative flex w-28 items-center lg:mb-6 lg:w-40",
      children: [/*#__PURE__*/_jsx("button", {
        className: "absolute left-2 w-5 lg:left-5 ",
        onClick: function onClick(event) {
          if (numberValue > min) {
            handleOnclickNumber(parseInt(numberValue, 10) - 1);
          }

          event.preventDefault();
        },
        children: "-"
      }), /*#__PURE__*/_jsx("button", {
        className: "absolute right-2 w-5 lg:right-5 ",
        onClick: function onClick(event) {
          if (numberValue < max) {
            handleOnclickNumber(parseInt(numberValue, 10) + 1);
          }

          event.preventDefault();
        },
        children: "+"
      }), /*#__PURE__*/_jsx("input", {
        className: "moz:appearance-none h-10 w-28 rounded-full border-zinc-200 text-center lg:w-40",
        type: "text",
        value: numberValue,
        onKeyPress: function onKeyPress(event) {
          if (!/[0-9]/.test(event.key)) {
            event.preventDefault();
          }
        },
        min: min,
        onChange: function onChange(event) {
          event.preventDefault();
          var newValue = event.target.value;

          if (newValue === "") {
            setNumberValue("");
          } else if (newValue < min) {
            setNumberValue(min);
          } else if (newValue > max) {
            setNumberValue(max);
          } else {
            setNumberValue(newValue);
          }
        },
        onBlur: function onBlur() {
          if (numberValue < min) {
            setNumberValue(min);
          }
        }
      })]
    })
  });
};
var CheckBox = function CheckBox(_ref5) {
  var _errors$name4;

  var name = _ref5.name,
      text = _ref5.text,
      register = _ref5.register,
      errors = _ref5.errors,
      checkboxTextClassName = _ref5.checkboxTextClassName,
      props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref5, _excluded4);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
      className: "relative block pl-7",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", _objectSpread(_objectSpread({
        type: "checkbox"
      }, register(name, {})), {}, {
        className: "bbc-checkbox absolute left-1 top-1 cursor-pointer rounded border-bbc-silver bg-transparent focus:shadow-none focus:outline-none focus:ring-0"
      }, props)), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: checkboxTextClassName ? checkboxTextClassName : "",
        dangerouslySetInnerHTML: {
          __html: text
        }
      })]
    }), errors[name] && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
      className: "inline-block pt-2 text-sm text-red-500",
      children: (_errors$name4 = errors[name]) === null || _errors$name4 === void 0 ? void 0 : _errors$name4.message
    })]
  });
};

/***/ }),

/***/ 78762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92809);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_google_recaptcha__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34853);
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1216);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var ReCaptcha = function ReCaptcha(props, ref) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_lazyload__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(react_google_recaptcha__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({
      ref: ref,
      sitekey: "6LeJZ68UAAAAAJZ8jxdgylEXeWL8P9Ckv7CLtE6t",
      badge: "inline",
      size: "invisible"
    }, props))
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(ReCaptcha));

/***/ }),

/***/ 85882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Toast; }
/* harmony export */ });
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30266);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(56727);
/* harmony import */ var common_contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72713);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97464);
/* harmony import */ var _ButtonNew_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30852);
/* harmony import */ var _Icon_fa_FaTimes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11856);
/* harmony import */ var _Index_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14388);
/* harmony import */ var _Index_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_Index_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);












var contentStatus = {
  success: {
    title: "Send Success",
    description: "We'll contact you all right away."
  },
  error: {
    title: "Send Error",
    description: "Please check your network connection and try again"
  }
};
var timer = null;

var RenderContent = function RenderContent(_ref) {
  var sendStatus = _ref.sendStatus,
      sendContent = _ref.sendContent,
      setIsOpen = _ref.setIsOpen;

  switch (sendStatus) {
    case "success":
      {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: "",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              src: "/assets/icons/checked.png",
              width: 90,
              height: 92,
              alt: "icon success",
              className: "mb-6"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "mb-6 text-2xl font-semibold text-bbc-brand-800",
            children: sendContent === null || sendContent === void 0 ? void 0 : sendContent.title
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "text-sm text-bbc-gray",
            children: sendContent === null || sendContent === void 0 ? void 0 : sendContent.description
          })]
        });
      }

    case "error":
      {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            src: "/assets/icons/error.png",
            width: 90,
            height: 92,
            alt: "icon error",
            className: "mb-6"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "mb-6 text-2xl font-semibold text-bbc-red-500",
            children: sendContent === null || sendContent === void 0 ? void 0 : sendContent.title
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "text-sm text-bbc-red-500",
            children: sendContent === null || sendContent === void 0 ? void 0 : sendContent.description
          })]
        });
      }

    case "confirm":
      {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            src: "/assets/icons/warning.png",
            width: 98,
            height: 100,
            alt: "icon error",
            className: "mx-auto mb-6",
            wrapper: {
              className: "block"
            }
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "mb-6 text-2xl font-semibold text-bbc-brand-700",
            children: sendContent === null || sendContent === void 0 ? void 0 : sendContent.title
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
            className: "flex justify-around",
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_ButtonNew_index__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
              variant: "outline",
              btnTextColor: "text-bbc-red-300 hover:text-white",
              btnBorder: "border border-bbc-red-300 hover:border-bbc-red-400",
              btnColor: "bg-transparent hover:bg-bbc-red-400",
              othersClass: "w-28",
              onClick: function onClick() {
                setIsOpen(false);
              },
              children: "No"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_ButtonNew_index__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
              othersClass: "w-28",
              onClick: function onClick() {
                sendContent.onClick();
                setIsOpen(false);
              },
              children: "Yes"
            })]
          })]
        });
      }

    case "custom":
      {
        return sendContent.element;
      }

    default:
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: "mb-6 text-2xl font-semibold text-bbc-red-600",
          children: contentStatus.error.title
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
          className: "text-sm",
          children: contentStatus.error.description
        })]
      });
  }
};

function Toast(_ref2) {
  var children = _ref2.children;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""),
      sendStatus = _useState2[0],
      setSendStatus = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""),
      sendContent = _useState3[0],
      setSendContent = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""),
      bgAlert = _useState4[0],
      setBgAlert = _useState4[1];
  /* Handle Event */


  var closeModal = function closeModal(otherAction) {
    setIsOpen(false);

    if (otherAction) {
      try {
        otherAction(); // eslint-disable-next-line no-empty
      } catch (error) {}
    }

    clearTimeout(timer);
    document.documentElement.removeAttribute("style");
  };

  var openAlert = /*#__PURE__*/function () {
    var _ref3 = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)( /*#__PURE__*/_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(time, status, content, otherAction) {
      var closeModalAfterTime;
      return _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              closeModalAfterTime = function _closeModalAfterTime(timeToClose) {
                return new Promise(function (resolve) {
                  timer = setTimeout(function () {
                    closeModal(otherAction);
                    resolve("closed");
                  }, timeToClose);
                });
              };

              if (content) {
                setSendContent(content);
              } else {
                setSendContent(contentStatus[status]);
              }

              _context.t0 = status;
              _context.next = _context.t0 === "success" ? 5 : _context.t0 === "error" ? 7 : _context.t0 === "confirm" ? 9 : _context.t0 === "custom" ? 11 : 13;
              break;

            case 5:
              setBgAlert("from-[#8CEBFE] to-[#F9F9F9]");
              return _context.abrupt("break", 14);

            case 7:
              setBgAlert("from-[#dd3333] to-[#F9F9F9]");
              return _context.abrupt("break", 14);

            case 9:
              setBgAlert("from-[#8CEBFE] to-[#F9F9F9]");
              return _context.abrupt("break", 14);

            case 11:
              setBgAlert(sendContent.bgAlert || "from-[#8CEBFE] to-[#F9F9F9]");
              return _context.abrupt("break", 14);

            case 13:
              return _context.abrupt("break", 14);

            case 14:
              setSendStatus(status);
              setIsOpen(true);

              if (!time) {
                _context.next = 19;
                break;
              }

              _context.next = 19;
              return closeModalAfterTime(time);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function openAlert(_x, _x2, _x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();
  /* Effect */


  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(common_contexts__WEBPACK_IMPORTED_MODULE_2__/* .ToastContext.Provider */ .uL.Provider, {
    value: {
      openAlert: openAlert,
      setOpenAlert: setIsOpen
    },
    children: [children, /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_8__/* .Transition */ .uT, {
      show: isOpen,
      as: "div",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_8__/* .Dialog */ .Vq, {
        open: isOpen,
        as: "div",
        className: "fixed inset-0  overflow-y-auto",
        onClose: closeModal,
        style: {
          zIndex: 100
        },
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "fixed inset-0 bg-black/30",
          "aria-hidden": "true"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
          className: "min-h-screen px-4 text-center",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_8__/* .Transition.Child */ .uT.Child, {
            as: react__WEBPACK_IMPORTED_MODULE_1__.Fragment,
            enter: "ease-out duration-300",
            enterFrom: "opacity-0",
            enterTo: "opacity-100",
            leave: "ease-in duration-200",
            leaveFrom: "opacity-100",
            leaveTo: "opacity-0",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_8__/* .Dialog.Overlay */ .Vq.Overlay, {
              className: "fixed inset-0 bg-slate-900 bg-opacity-70"
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("span", {
            className: "inline-block h-screen align-middle",
            "aria-hidden": "true",
            children: "\u200B"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_8__/* .Transition.Child */ .uT.Child, {
            as: react__WEBPACK_IMPORTED_MODULE_1__.Fragment,
            enter: "ease-out duration-300",
            enterFrom: "opacity-0 scale-95",
            enterTo: "opacity-100 scale-100",
            leave: "ease-in duration-200",
            leaveFrom: "opacity-100 scale-100",
            leaveTo: "opacity-0 scale-95",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
              className: "".concat((_Index_module_scss__WEBPACK_IMPORTED_MODULE_9___default().ToastContent), " relative inline-flex w-full flex-col  justify-center border-2 bg-gradient-to-b px-7  py-28 text-center align-middle transition-all ").concat(bgAlert, " rounded-2xl shadow-xl"),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
                className: "absolute top-6 right-4",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("button", {
                  type: "button",
                  className: "inline-flex justify-center rounded-full border-2 border-white p-1 text-xs  font-medium text-white transition-all  hover:border-bbc-red-300 hover:text-bbc-red-300 focus:outline-none ",
                  onClick: closeModal,
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_Icon_fa_FaTimes__WEBPACK_IMPORTED_MODULE_5__/* .FaTimes */ .a, {
                    size: 12
                  })
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
                className: "relative ",
                children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(RenderContent, {
                  sendContent: sendContent,
                  sendStatus: sendStatus,
                  setIsOpen: setIsOpen
                })
              })]
            })
          })]
        })]
      })
    })]
  });
}

/***/ }),

/***/ 88279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(30266);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(87536);
/* harmony import */ var common_contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72713);
/* harmony import */ var common_fetch_getGAUserID__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(12453);
/* harmony import */ var common_fetch_post__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92559);
/* harmony import */ var common_trigger__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(62951);
/* harmony import */ var components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30852);
/* harmony import */ var components_atoms_Icon_bi_BiLoaderAlt__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7778);
/* harmony import */ var components_atoms_Input_index__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66865);
/* harmony import */ var components_atoms_Recaptcha_index__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(78762);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31741);
/* harmony import */ var components_atoms_Toast__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85882);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(85893);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













/** ========== */




var FormCountry = function FormCountry(_ref) {
  var country_id = _ref.country_id;

  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(common_contexts__WEBPACK_IMPORTED_MODULE_3__/* .ToastContext */ .uL),
      openAlert = _useContext.openAlert;

  var _useForm = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_12__/* .useForm */ .cI)(),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit,
      reset = _useForm.reset,
      clearErrors = _useForm.clearErrors,
      _useForm$formState = _useForm.formState,
      isSubmitting = _useForm$formState.isSubmitting,
      errors = _useForm$formState.errors;

  var recaptchaRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();

  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)( /*#__PURE__*/_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data) {
      var token, GAUserID, dataSend;
      return _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return recaptchaRef.current.executeAsync();

            case 2:
              token = _context.sent;

              if (token) {
                GAUserID = (0,common_fetch_getGAUserID__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)();
                dataSend = _objectSpread({}, data);
                dataSend.client_id = GAUserID ? GAUserID : "";
                dataSend.website_id = "1";
                dataSend.company_country_id = country_id;

                try {
                  (0,common_fetch_post__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                    api: "".concat("https://core.test-lp.bbcincorp.com", "/api/portal/contact_form/question"),
                    data: dataSend,
                    token: token
                  }).then(function (res) {
                    if (res.state) {
                      (0,common_trigger__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)("contact_form", dataSend, "Contact form");
                      openAlert(2000, "success");
                      reset();
                    } else {
                      openAlert(3000, "error");
                      console.log("error");
                    }
                  })["catch"](function (e) {
                    openAlert(3000, "error");
                    console.log("error", e);
                  });
                } catch (e) {
                  clearErrors();
                  openAlert(3000, "error");
                  console.log("error", e);
                }
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("form", {
    onSubmit: handleSubmit(onSubmit),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
      className: "mb-6 lg:mb-10",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(components_atoms_Input_index__WEBPACK_IMPORTED_MODULE_7__/* .InputText */ .oH, {
        register: register,
        errors: errors,
        name: "first_name",
        placeholder: "Name*",
        requiredText: "Name is required"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
      className: "mb-6 lg:mb-10",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(components_atoms_Input_index__WEBPACK_IMPORTED_MODULE_7__/* .InputEmail */ .j7, {
        register: register,
        errors: errors
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
      className: "mb-6 lg:mb-10",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(components_atoms_Input_index__WEBPACK_IMPORTED_MODULE_7__/* .InputText */ .oH, {
        as: "textarea",
        register: register,
        errors: errors,
        name: "message",
        placeholder: "Message*",
        requiredText: "Message is required"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
      className: "flex flex-wrap items-center justify-between",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
        className: "col-12 mb-6 text-center lg:col-auto  lg:mb-0",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
          className: "inline-block",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(components_atoms_Recaptcha_index__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            ref: recaptchaRef,
            className: "mx-auto w-max"
          })
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
        className: "col-12 text-center lg:col-auto",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)(components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
          type: "submit",
          style: {
            minWidth: "170px"
          },
          disabled: isSubmitting,
          children: [isSubmitting && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(components_atoms_Icon_bi_BiLoaderAlt__WEBPACK_IMPORTED_MODULE_6__/* .BiLoaderAlt */ .s, {
            className: "mr-2 inline-block animate-spin",
            size: 20
          }), "Send Your Message"]
        })
      })]
    })]
  });
};
/** ========== */


var FormCountries = function FormCountries(_ref3) {
  var title = _ref3.title,
      description = _ref3.description,
      descriptionClass = _ref3.descriptionClass,
      contentBottom = _ref3.contentBottom,
      country_id = _ref3.country_id;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("div", {
    className: "rounded-3xl bg-white px-3  py-6 lg:px-10 lg:py-[50px]",
    style: {
      boxShadow: "0px 16px 40px rgba(181, 181, 181, 0.25)"
    },
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
      text: title,
      className: "mb-6 text-bbc-30px font-semibold capitalize text-bbc-brand-800 lg:mb-10 lg:text-center lg:text-bbc-40px"
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("p", {
      className: "".concat(descriptionClass ? descriptionClass : "mb-6 text-center lg:mb-10"),
      children: description
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(components_atoms_Toast__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(FormCountry, {
        country_id: country_id
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
      children: contentBottom
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (FormCountries);
FormCountries.defaultProps = {
  title: "",
  description: "",
  nameProps: {},
  emailProps: {},
  messageProps: {}
};
/** ========== */

/***/ }),

/***/ 37768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31741);
/* harmony import */ var components_molecules_FaqsGroup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69156);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


/* ========== */





var Component = function Component(_ref) {
  var data = _ref.data,
      title = _ref.title,
      description = _ref.description,
      defaultActiveKey = _ref.defaultActiveKey,
      multipleOpen = _ref.multipleOpen,
      buttonClass = _ref.buttonClass,
      panelClass = _ref.panelClass;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
      text: title || "Frequently Asked Questions",
      className: "mb-6 text-center text-bbc-30px font-semibold text-bbc-brand-800  lg:text-bbc-40px "
    }), description ? description.trim().length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("p", {
      className: "mb-6 text-center lg:mb-10",
      children: description
    }) :
    /*#__PURE__*/
    // <p className="text-center mb-6 lg:mb-10">
    //   Know more about our nominee service with commonly asked questions.
    // </p>
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_molecules_FaqsGroup__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      data: data,
      haveTabs: !Array.isArray(data),
      defaultActiveKey: defaultActiveKey || false,
      multipleOpen: multipleOpen || false,
      buttonClass: buttonClass,
      panelClass: panelClass
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Component);

/***/ }),

/***/ 91630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TrustpilotFeedBack; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(92809);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 94 modules
var swiper_esm = __webpack_require__(88116);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 13 modules
var swiper_react = __webpack_require__(98352);
// EXTERNAL MODULE: ./node_modules/swiper/modules/navigation/navigation.min.css
var navigation_min = __webpack_require__(92);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(68770);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(30933);
// EXTERNAL MODULE: ./components/atoms/Icon/iconBase.js + 1 modules
var iconBase = __webpack_require__(98851);
;// CONCATENATED MODULE: ./components/atoms/Icon/gr/GrFormNext.js

function GrFormNext(props) {
  return (0,iconBase/* GenIcon */.w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 24 24"
    },
    "child": [{
      "tag": "polyline",
      "attr": {
        "fill": "none",
        "stroke": "#000",
        "strokeWidth": "2",
        "points": "9 6 15 12 9 18"
      }
    }]
  })(props);
}
;
// EXTERNAL MODULE: ./components/atoms/Icon/si/SiTrustpilot.js
var SiTrustpilot = __webpack_require__(9633);
// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./components/organisms/TrustpilotFeedBack/Index.module.scss
var Index_module = __webpack_require__(29850);
var Index_module_default = /*#__PURE__*/__webpack_require__.n(Index_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/organisms/TrustpilotFeedBack/index.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













var dataStar = new Array(5).fill(1);
var swiper = {
  preloadImages: false,
  lazy: true,
  loop: false,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
    pauseOnMouseEnter: true
  },
  pagination: {
    el: ".swiper-trustpilot-dots",
    clickable: true,
    bulletClass: "bbc-pagination-bullet",
    bulletActiveClass: "bbc-pagination-bullet-active"
  },
  navigation: {
    nextEl: ".swiper-trustpilot-next",
    prevEl: ".swiper-trustpilot-prev"
  },
  slidesPerView: 1,
  spaceBetween: 40
};

var Component = function Component(_ref) {
  var data = _ref.data;

  var _useState = (0,react.useState)(null),
      thumbsSwiper = _useState[0],
      setThumbsSwiper = _useState[1];

  function isImage(url) {
    // eslint-disable-next-line prefer-named-capture-group
    return /\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(url);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "mt-6 justify-between lg:mt-10 lg:flex",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "col-12 lg:col-6",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, _objectSpread(_objectSpread({
        spaceBetween: 10,
        thumbs: {
          swiper: thumbsSwiper
        },
        modules: [swiper_esm/* Autoplay */.pt, swiper_esm/* Navigation */.W_, swiper_esm/* Thumbs */.o3, swiper_esm/* Pagination */.tl]
      }, swiper), {}, {
        className: "swiperFeelback bg-bbc-main ",
        children: data.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
            className: "p-3 lg:p-0",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: " w-full rounded-3xl bg-white py-6 px-8 shadow-[0px_0px_12px_rgba(119,119,119,0.25)] lg:rounded-none  lg:bg-transparent lg:p-0 lg:shadow-none",
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                className: "flex justify-center lg:justify-start",
                children: [isImage(item.avatar) ? /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                  src: item.avatar,
                  className: "mr-6 rounded-full",
                  alt: item.name,
                  width: 80,
                  height: 80
                }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "".concat((Index_module_default()).avatar, " mr-6 flex items-center justify-center rounded-full font-bold"),
                  style: {
                    backgroundColor: item.bgAvatar
                  },
                  children: item.avatar
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: "mb-2  text-bbc-neutral-700",
                    children: item.name
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "flex",
                    children: dataStar.map(function (item, index) {
                      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                        className: "mr-1 flex h-6 w-6 items-center justify-center bg-[#00b67a] shadow-md",
                        children: /*#__PURE__*/(0,jsx_runtime.jsx)(SiTrustpilot/* SiTrustpilot */.A, {
                          className: "text-xl text-bbc-white"
                        })
                      }, index);
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                    className: "align-items-end mt-3  flex",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "mr-0.5",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)(SiTrustpilot/* SiTrustpilot */.A, {
                        className: "text-2xl text-[#00b67a]"
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "text-xl font-medium text-bbc-black",
                      children: "Trustpilot"
                    })]
                  })]
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "my-4 text-center font-semibold text-[#0042A3] opacity-[0.8] lg:text-left",
                children: item.title
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: " text-center text-bbc-gray lg:text-left",
                children: item.content
              })]
            })
          }, index);
        })
      }))
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "relative  text-center lg:col-6",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: " hidden lg:flex lg:justify-center",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
          onSwiper: setThumbsSwiper,
          spaceBetween: 5,
          slidesPerView: 3,
          freeMode: true,
          allowTouchMove: false,
          modules: [swiper_esm/* FreeMode */.Rv, swiper_esm/* Navigation */.W_, swiper_esm/* Thumbs */.o3, swiper_esm/* Pagination */.tl],
          className: "swiperAvatar col-5 mr-2.5 ml-0",
          children: data.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
              className: "text-center",
              children: isImage(item.avatar) ? /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                src: item.avatar,
                className: "cursor-pointer rounded-full",
                alt: "avatar",
                width: 60,
                height: 60
              }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "mx-auto flex  items-center justify-center rounded-full text-2xl font-bold",
                style: {
                  width: "60px",
                  height: "60px",
                  backgroundColor: item.bgAvatar
                },
                children: item.avatar
              })
            }, index);
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: " mt-6 hidden h-16 lg:block",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "swiper-trustpilot-next absolute flex h-16 w-16 cursor-pointer items-center justify-center rounded-full ".concat((Index_module_default()).btnNext, " "),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(GrFormNext, {
            className: " text-3xl"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "swiper-trustpilot-prev absolute  flex h-16 w-16 cursor-pointer items-center justify-center rounded-full ".concat((Index_module_default()).btnPrev, " "),
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(GrFormNext, {
            className: "rotate-180 text-3xl"
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "swiper-trustpilot-dots  pt-6 "
      })]
    })]
  });
};

/* harmony default export */ var TrustpilotFeedBack = (Component);

/***/ }),

/***/ 81178:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./components/common/Layout/index.js + 26 modules
var Layout = __webpack_require__(19738);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/headlessui.esm.js
var headlessui_esm = __webpack_require__(56727);
// EXTERNAL MODULE: ./common/data/trustpilot/data.json
var data = __webpack_require__(54356);
// EXTERNAL MODULE: ./common/hooks/useResizeScreenModified.js
var useResizeScreenModified = __webpack_require__(77450);
// EXTERNAL MODULE: ./components/atoms/Img/index.js
var Img = __webpack_require__(97464);
// EXTERNAL MODULE: ./components/atoms/LinkRouter/index.js
var LinkRouter = __webpack_require__(27597);
// EXTERNAL MODULE: ./components/atoms/Title/index.js
var Title = __webpack_require__(31741);
// EXTERNAL MODULE: ./components/molecules/FaqsGroup/index.js + 1 modules
var FaqsGroup = __webpack_require__(69156);
// EXTERNAL MODULE: ./components/molecules/FormCountries/index.js
var FormCountries = __webpack_require__(88279);
// EXTERNAL MODULE: ./components/molecules/TabListNew/index.js
var TabListNew = __webpack_require__(32144);
// EXTERNAL MODULE: ./components/organisms/Banner/index.js + 6 modules
var Banner = __webpack_require__(47447);
// EXTERNAL MODULE: ./components/organisms/Faqs/index.js
var Faqs = __webpack_require__(37768);
// EXTERNAL MODULE: ./components/organisms/TrustpilotFeedBack/index.js + 1 modules
var TrustpilotFeedBack = __webpack_require__(91630);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/templates/offshore/corporate-secretary/index.js

















var Component = function Component(_ref) {
  var dataJson = _ref.dataJson;

  var _useState = (0,react.useState)(),
      screen = _useState[0],
      setScreen = _useState[1];

  (0,useResizeScreenModified/* default */.Z)(setScreen);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Banner/* default */.Z, {
      minHeightBanner: "banner-fix-min-h-569",
      wave: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "col-12 absolute bottom-0 hidden lg:block ",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
          src: "/assets/images/wave/curve_top-wave.svg",
          className: "h-full w-full",
          width: 516,
          wrapper: {
            className: "w-full h-full"
          },
          height: 420,
          alt: "banner-img"
        })
      }),
      breadcrumbs: dataJson === null || dataJson === void 0 ? void 0 : dataJson.breadcrumbs,
      title: "Corporate<br/>Secretarial Services",
      leftContent: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "mb-6 text-center lg:col-11 lg:mb-14 lg:text-left",
        children: "Incorporating your business in another state means getting through who-knows-how-many legal gymnastics. BBCIncorp offers tailored and modern corporate secretarial services that make sure your company stay compliant no matter the destination."
      }),
      titleProps: {
        className: "banner-default-title mb-6",
        textColor: "banner-title-default-color"
      },
      leftClassName: "lg:col-7",
      rightClassName: "lg:col-5",
      rightContent: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "relative bottom-0 h-auto w-full bg-no-repeat lg:absolute lg:w-[666px] ",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
          src: "/assets/images/offshore/corporate-secretary/banner-offshore-secretary.png",
          className: "h-full w-full",
          wrapper: {
            className: "bbc-banner-image-bottom-0"
          },
          width: 580,
          height: 488,
          alt: "corporate secretarial service"
        })
      }),
      bgColor: "bg-bbc-country"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "bg-bbc-brand-100 pt-10 lg:pt-20",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          className: "title-h2 mb-4 text-center text-bbc-brand-800  lg:mb-6 ",
          children: "Stay compliant anywhere, anytime"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: "Our network of professional company secretaries are always ready to provide you with bespoke consultation for +15 jurisdictions worldwide. They take care of all your compliance related matters so you can focus on growing your business."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "mt-10",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "row items-center justify-between",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "lg:col-6",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
                as: "h3",
                className: "bbc-title-30 ",
                children: "Keeping up with regulatory changes"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: "Offshore jurisdictions tend to have a more dynamic legal landscape and are therefore more susceptible to change. When that happens, you\u2018ll be one of the first to know."
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "text-center lg:col-6 lg:text-right",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                src: "/assets/images/offshore/corporate-secretary/services1-offshore-secretary.png",
                width: 475,
                height: 480,
                alt: "keep up with regulatory changes"
              })
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "mt-10",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "row flex-col-reverse items-center justify-between lg:flex-row",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "text-center lg:col-6 lg:text-left",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                src: "/assets/images/offshore/corporate-secretary/services2-offshore-secretary.png",
                width: 502,
                height: 460,
                alt: "avoid troubles"
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "lg:col-6",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
                as: "h3",
                className: "bbc-title-30",
                children: "Avoiding legal trouble"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: "Not paying a fee or filing a form on time can get your company fined and placed higher on the legislators\u2018 pecking list. Overtime, these numbers will add up and be detrimenta l to your bottom line."
              })]
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "mt-10",
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "row items-center justify-between ",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "lg:col-6",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
                as: "h3",
                className: "bbc-title-30",
                children: "Staying compliant all the time"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                children: "Although some jurisdictions allow the key personnel (e.g director, shareholder) to also act as a corporate secretary, others don\u2018t adopt the same practice and would require you to enlist service from a third-party provider."
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "text-center lg:col-6 lg:text-right",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
                src: "/assets/images/offshore/corporate-secretary/services3-offshore-secretary.png",
                width: 504,
                height: 452,
                alt: "stay compliant all the time"
              })
            })]
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "col-12 mb-10 hidden lg:mb-20 lg:block",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
        src: "/assets/images/wave/curve_bot-wave.svg",
        className: "h-full w-full",
        width: 516,
        height: 420,
        wrapper: {
          className: "w-full h-full"
        },
        alt: "banner-img"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
          className: "title-h2 mb-6 text-center font-semibold text-bbc-brand-800 lg:mb-10",
          children: "Pricing"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TabListNew/* default */.Z, {
          data: dataJson.dataPricing.data.map(function (item) {
            return item.tab;
          }),
          activeTab: dataJson.dataPricing.activeTab,
          tabListClass: {
            display: "flex lg:justify-center",
            length: "w-full",
            padding: "px-1 py-3",
            border: "border-0",
            othersClass: "whitespace-nowrap overflow-x-auto mb-6"
          },
          tabClass: {
            padding: "py-2 px-4 ",
            tabColor: "text-bbc-neutral-600 border-bbc-neutral-600 hover:text-bbc-brand-500 hover:border-bbc-brand-500",
            othersClass: "mr-2 last:mr-0 font-medium"
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Tab.Panels */.OK.Panels, {
            children: dataJson.dataPricing.data.map(function (item, index) {
              var _item$table, _item$table$thead, _item$table2, _item$table2$tbody, _item$table3, _item$table3$tbody;

              return /*#__PURE__*/(0,jsx_runtime.jsxs)(headlessui_esm/* Tab.Panel */.OK.Panel, {
                className: "focus:outline-none focus:outline-0 focus:ring-0",
                as: "div",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "shadow-bbc-table mt-10 hidden overflow-x-auto rounded-3xl lg:block",
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)("table", {
                    className: " text-left text-sm text-bbc-gray",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("thead", {
                      className: "col-12 bg-bbc-brand-700  text-2xl  text-bbc-white ",
                      children: /*#__PURE__*/(0,jsx_runtime.jsx)("tr", {
                        children: (_item$table = item.table) === null || _item$table === void 0 ? void 0 : (_item$table$thead = _item$table.thead) === null || _item$table$thead === void 0 ? void 0 : _item$table$thead.map(function (thead, index) {
                          return /*#__PURE__*/(0,jsx_runtime.jsx)("th", {
                            className: "".concat(thead.width, " py-8 text-center font-semibold"),
                            children: thead.name
                          }, index);
                        })
                      })
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)("tbody", {
                      children: (_item$table2 = item.table) === null || _item$table2 === void 0 ? void 0 : (_item$table2$tbody = _item$table2.tbody) === null || _item$table2$tbody === void 0 ? void 0 : _item$table2$tbody.map(function (thead, index) {
                        return /*#__PURE__*/(0,jsx_runtime.jsxs)("tr", {
                          className: " bg-bbc-white even:bg-bbc-brand-100",
                          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("th", {
                            className: "w-1/6 px-4 py-6 align-top font-medium text-bbc-brand-700",
                            children: thead.title
                          }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                            className: "w-4/6 py-6",
                            children: /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                              className: "border-x border-bbc-neutral-700 px-6",
                              children: thead.description
                            })
                          }), /*#__PURE__*/(0,jsx_runtime.jsx)("td", {
                            className: "w-1/6 px-4 py-6 align-top",
                            children: thead.price ? thead.price : /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                              href: "/contact-us",
                              className: "font-semibold text-bbc-brand-700 ",
                              children: "Contact us"
                            })
                          })]
                        }, index);
                      })
                    })]
                  })
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "mt-6 block lg:hidden",
                  children: (_item$table3 = item.table) === null || _item$table3 === void 0 ? void 0 : (_item$table3$tbody = _item$table3.tbody) === null || _item$table3$tbody === void 0 ? void 0 : _item$table3$tbody.map(function (item, index) {
                    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      className: "mb-4  rounded-2xl bg-bbc-white shadow-[0_16px_40px_0_rgba(181,181,181,0.25)]",
                      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
                        className: "border-b border-bbc-neutral-500 py-4 text-center font-medium text-bbc-brand-600",
                        children: item.title
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                        className: "border-b border-bbc-neutral-500 py-6 px-7 text-center",
                        children: item.description
                      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                        className: "py-4 text-center",
                        children: item.price ? item.price : /*#__PURE__*/(0,jsx_runtime.jsx)(LinkRouter/* default */.Z, {
                          href: "/contact-us",
                          className: "font-semibold text-bbc-brand-700 ",
                          children: "Contact us"
                        })
                      })]
                    }, index);
                  })
                })]
              }, index);
            })
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Title/* default */.Z, {
          className: "title-h2 mb-4 text-center normal-case text-bbc-brand-800 lg:mb-6",
          children: ["Proactive, Professional, and Passionate", " "]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: " text-center",
          children: "Whatever business you\u2019re doing, be confident you\u2019re in good hands."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "text-center",
          children: "When it comes to corporate secretarial service, you won\u2019t find a more committed team."
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "row mt-10 justify-center",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "mt-6 flex items-center lg:col-5 lg:mr-6",
            children: screen === "DESKTOP" ? /*#__PURE__*/(0,jsx_runtime.jsx)(FaqsGroup/* default */.Z, {
              data: dataJson.dataProactive
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
              children: dataJson.dataProactive.map(function (item, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
                  className: "mx-4 mb-10 text-center",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "mb-4",
                    dangerouslySetInnerHTML: {
                      __html: item.name
                    }
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    dangerouslySetInnerHTML: {
                      __html: item.content
                    }
                  })]
                }, index);
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "order-first lg:col-6 lg:order-last lg:ml-6",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(Img/* default */.Z, {
              src: "/assets/images/offshore/corporate-secretary/service_strong-offshore-secretary.png",
              width: 539,
              height: 422,
              alt: "why choose our service"
            })
          })]
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "m-auto lg:col-10",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
            className: "title-h2 mb-4 text-center text-bbc-brand-800 lg:mb-6 lg:text-left ",
            children: "What customers say about BBCIncorp"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "text-center",
            children: "Our skillful secretary have helped thousands of businesses like yours with their corporate governance."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(TrustpilotFeedBack/* default */.Z, {
            data: data/* feedback */.I
          })]
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "m-auto lg:col-10",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Faqs/* default */.Z // Description="0"
          , {
            data: dataJson.dataFaqs
          })
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "m-auto lg:col-10",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(FormCountries/* default */.Z, {
            title: dataJson.dataFormContact.title,
            description: dataJson.dataFormContact.description
          })
        })
      })
    })]
  });
};

/* harmony default export */ var corporate_secretary = (Component);
;// CONCATENATED MODULE: ./pages/offshore/corporate-secretary/data.json
var corporate_secretary_data_namespaceObject = JSON.parse('{"breadcrumbs":[{"uri":"/","title":"Home"},{"uri":"/corporate-secretary","title":"Corporate Secretarial Services"}],"dataPricing":{"activeTab":0,"data":[{"tab":"Change Company Particulars","table":{"thead":[{"name":"Items","width":"w-1/6"},{"name":"Description","width":"w-4/6"},{"name":"Price","width":"w-1/6"}],"tbody":[{"title":"Company name","description":"We help you to check your company name\'s uniqueness, ensure legal compliance and file name change to the Registrar and other relevant local authorities.","price":""},{"title":"Registered address","description":"In order to change your registered address, you are required to report the change to the relevant authority and have an updated Business Registration Certificate.","price":""},{"title":"Articles of Associations","description":"Your company might want to change the articles of association to fulfil your operation needs - i.e, hold a general meeting or issue new classes of shares. To change the Articles of Association, your company must submit the required form at the relevant authority.","price":""},{"title":"Business activities","description":"Your company is required to notify the relevant authority in writing (through prescribed forms) of the business particulars, including description and nature of your business.","price":""}]}},{"tab":"Change company\'s officers","table":{"thead":[{"name":"Items","width":"w-1/6"},{"name":"Description","width":"w-4/6"},{"name":"Price","width":"w-1/6"}],"tbody":[{"title":"Change officer\'s particulars ","description":"You must update the change of officer\'s particulars such as name, identification number, residential address, etc. to the relevant authority to avoid penalty.","price":""},{"title":"Appoint new officers","description":"Including changes of 1 personnel, US$100 for additional change each","price":""},{"title":"Remove/Resign officers","description":"Including changes of 1 personnel, US$100 for additional change each","price":""}]}},{"tab":"Share related changes","table":{"thead":[{"name":"Items","width":"w-1/6"},{"name":"Description","width":"w-4/6"},{"name":"Price","width":"w-1/6"}],"tbody":[{"title":"Increase/Decrease of capital","description":"Share certificates after the allotment registration are issued to shareholders to typically raise new finance.","price":""},{"title":"Issue and allot shares","description":"Share certificates after the allotment registration are issued to shareholders to typically raise new finance.","price":""},{"title":"Transfer shares","description":"Upon demand for transfer of shares to withdraw from a company or to realize profits, we help you prepare and file share transfer documents.","price":""},{"title":"Pay dividend","description":"Dividend distribution is eigible after the board of director\'s approval. We help you arrange all related internal procedures and ensure the legitimacy with the governing legislation.","price":""}]}},{"tab":"Annual compliance","table":{"thead":[{"name":"Items","width":"w-1/6"},{"name":"Description","width":"w-4/6"},{"name":"Price","width":"w-1/6"}],"tbody":[{"title":"Tax return filing","description":"You must file tax returns to the tax authority, regardless of making a profit in a financial year or not, by submitting prescribed form with declaration of chargable income substantiated with financial statements. ","price":""},{"title":"Economic substance filing ","description":"All tax-resident entities performing relevant activities must demonstrate economic substance in the applicablle jurisdiction.","price":""}]}},{"tab":"Document retrieval","table":{"thead":[{"name":"Items","width":"w-1/6"},{"name":"Description","width":"w-4/6"},{"name":"Price","width":"w-1/6"}],"tbody":[{"title":"Certificate of Incumbency ","description":"Certificate of Incumbency(CI), an official document issued by relevant authorities to list actual directors/ officers/ key shareholders, is required to open corporate bank account. ","price":""},{"title":"Certificate of Good Standing","description":"A Certificate of Good Standing (CGS) is an official document issued by the Companies Register to confirm a company\'s legal existence and due delligence as of the issuance date.","price":""}]}}]},"dataProactive":[{"name":"<span class=\'text-2xl text-bbc-brand-700 font-semibold\'>Dedicated support</span>","content":"<p>Our service charges are based on volume and complexity of your transactions. We offer multiple service pricing tiers which can easily adapt to various business purposes and sizes.</p>"},{"name":"<span class=\'text-2xl text-bbc-brand-700 font-semibold\'>Time-saving</span>","content":"<p>We currently use Xero for accounting purpose. But do not worry, our local accounting team can undoubtedly handle if you want to use other ones.</p>"},{"name":"<span class=\'text-2xl text-bbc-brand-700 font-semibold\'>Transparent pricing</span>","content":"<p>You can rest assured that your data will be safe with us. We reinforce security of clients&quot; data based on three pillars:</p><ul><li>We have enforced data security policy in place to govern activities of internal departments and staffs involving in dealing with data and information.</li><li>Secured data servers with restricted access and frequent monitoring on safety of information.</li><li>Public privacy policy to our clients and contractual commitment by Non-disclosure agreement.</li></ul>"}],"dataFaqs":[{"name":"What key duties does a company secretary performs?","content":"<p>A company secretary holds two positions, one as an administrative officer responsible for informing key members of important regulative changes while also acting as the mediator between the company and the legislator(s)</p>"},{"name":"Do I need a corporate secretary?","content":"<p>It depends on the regulatory governance law in the country you\'re planning to setup in.  For example, the British Virgin Isles does not require a company secretary following incorporation. whereas Panama mandates it among other key personnel requirements (e.g. president, treasurer, and a Secretary).</p><p>If you need further assistance on this matter, please give our staff a call or drop them a message</p>"},{"name":"Are there any risks I should be aware of when hiring one?","content":"<p>Corporate secterial work has evolved to become highly efficient and dependable and are therefore relatively risk-free. Firms have implemented various contingency plans in the event that the corporate secretary in charge no longer is able to resume his duties. So rest assured, your company will be well taken care of when time comes.</p>"}],"dataFormContact":{"title":"Ready to switch to BBCIncorp","description":"If you would like to switch to our services, we are more than happy to assist. Just fill out the form below to receive free consulting for a smooth transition."}}');
;// CONCATENATED MODULE: ./pages/offshore/corporate-secretary/index.js




var __N_SSG = true;
function Home(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* default */.Z, {
      locationRouter: "offshore",
      page: data.page,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(corporate_secretary, {
        posts: data === null || data === void 0 ? void 0 : data.posts,
        dataJson: corporate_secretary_data_namespaceObject
      })
    })
  });
}

/***/ }),

/***/ 6805:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/offshore/corporate-secretary",
      function () {
        return __webpack_require__(81178);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 14388:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ToastContent":"Index_ToastContent__WZ1XO"};

/***/ }),

/***/ 29850:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"avatar":"Index_avatar__N4Fw5","btnNext":"Index_btnNext__swLTJ","btnPrev":"Index_btnPrev__KZ1Lh"};

/***/ }),

/***/ 92:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 68770:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 30933:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 34853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm; }
});

// UNUSED EXPORTS: ReCAPTCHA

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/recaptcha.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var ReCAPTCHA =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReCAPTCHA, _React$Component);

  function ReCAPTCHA() {
    var _this;

    _this = _React$Component.call(this) || this;
    _this.handleExpired = _this.handleExpired.bind(_assertThisInitialized(_this));
    _this.handleErrored = _this.handleErrored.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleRecaptchaRef = _this.handleRecaptchaRef.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = ReCAPTCHA.prototype;

  _proto.getValue = function getValue() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this.props.grecaptcha.getResponse(this._widgetId);
    }

    return null;
  };

  _proto.getWidgetId = function getWidgetId() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this._widgetId;
    }

    return null;
  };

  _proto.execute = function execute() {
    var grecaptcha = this.props.grecaptcha;

    if (grecaptcha && this._widgetId !== undefined) {
      return grecaptcha.execute(this._widgetId);
    } else {
      this._executeRequested = true;
    }
  };

  _proto.executeAsync = function executeAsync() {
    var _this2 = this;

    return new Promise(function (resolve, reject) {
      _this2.executionResolve = resolve;
      _this2.executionReject = reject;

      _this2.execute();
    });
  };

  _proto.reset = function reset() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      this.props.grecaptcha.reset(this._widgetId);
    }
  };

  _proto.handleExpired = function handleExpired() {
    if (this.props.onExpired) {
      this.props.onExpired();
    } else {
      this.handleChange(null);
    }
  };

  _proto.handleErrored = function handleErrored() {
    if (this.props.onErrored) {
      this.props.onErrored();
    }

    if (this.executionReject) {
      this.executionReject();
      delete this.executionResolve;
      delete this.executionReject;
    }
  };

  _proto.handleChange = function handleChange(token) {
    if (this.props.onChange) {
      this.props.onChange(token);
    }

    if (this.executionResolve) {
      this.executionResolve(token);
      delete this.executionReject;
      delete this.executionResolve;
    }
  };

  _proto.explicitRender = function explicitRender() {
    if (this.props.grecaptcha && this.props.grecaptcha.render && this._widgetId === undefined) {
      var wrapper = document.createElement("div");
      this._widgetId = this.props.grecaptcha.render(wrapper, {
        sitekey: this.props.sitekey,
        callback: this.handleChange,
        theme: this.props.theme,
        type: this.props.type,
        tabindex: this.props.tabindex,
        "expired-callback": this.handleExpired,
        "error-callback": this.handleErrored,
        size: this.props.size,
        stoken: this.props.stoken,
        hl: this.props.hl,
        badge: this.props.badge
      });
      this.captcha.appendChild(wrapper);
    }

    if (this._executeRequested && this.props.grecaptcha && this._widgetId !== undefined) {
      this._executeRequested = false;
      this.execute();
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    this.explicitRender();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.explicitRender();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this._widgetId !== undefined) {
      this.delayOfCaptchaIframeRemoving();
      this.reset();
    }
  };

  _proto.delayOfCaptchaIframeRemoving = function delayOfCaptchaIframeRemoving() {
    var temporaryNode = document.createElement("div");
    document.body.appendChild(temporaryNode);
    temporaryNode.style.display = "none"; // move of the recaptcha to a temporary node

    while (this.captcha.firstChild) {
      temporaryNode.appendChild(this.captcha.firstChild);
    } // delete the temporary node after reset will be done


    setTimeout(function () {
      document.body.removeChild(temporaryNode);
    }, 5000);
  };

  _proto.handleRecaptchaRef = function handleRecaptchaRef(elem) {
    this.captcha = elem;
  };

  _proto.render = function render() {
    // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.

    /* eslint-disable no-unused-vars */
    var _this$props = this.props,
        sitekey = _this$props.sitekey,
        onChange = _this$props.onChange,
        theme = _this$props.theme,
        type = _this$props.type,
        tabindex = _this$props.tabindex,
        onExpired = _this$props.onExpired,
        onErrored = _this$props.onErrored,
        size = _this$props.size,
        stoken = _this$props.stoken,
        grecaptcha = _this$props.grecaptcha,
        badge = _this$props.badge,
        hl = _this$props.hl,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "onErrored", "size", "stoken", "grecaptcha", "badge", "hl"]);
    /* eslint-enable no-unused-vars */


    return react.createElement("div", _extends({}, childProps, {
      ref: this.handleRecaptchaRef
    }));
  };

  return ReCAPTCHA;
}(react.Component);


ReCAPTCHA.displayName = "ReCAPTCHA";
ReCAPTCHA.propTypes = {
  sitekey: (prop_types_default()).string.isRequired,
  onChange: (prop_types_default()).func,
  grecaptcha: (prop_types_default()).object,
  theme: prop_types_default().oneOf(["dark", "light"]),
  type: prop_types_default().oneOf(["image", "audio"]),
  tabindex: (prop_types_default()).number,
  onExpired: (prop_types_default()).func,
  onErrored: (prop_types_default()).func,
  size: prop_types_default().oneOf(["compact", "normal", "invisible"]),
  stoken: (prop_types_default()).string,
  hl: (prop_types_default()).string,
  badge: prop_types_default().oneOf(["bottomright", "bottomleft", "inline"])
};
ReCAPTCHA.defaultProps = {
  onChange: function onChange() {},
  theme: "light",
  type: "image",
  tabindex: 0,
  size: "normal",
  badge: "bottomright"
};
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ./node_modules/react-async-script/lib/esm/async-script-loader.js
function async_script_loader_extends() { async_script_loader_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return async_script_loader_extends.apply(this, arguments); }

function async_script_loader_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function async_script_loader_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function

var idCount = 0;
function makeAsyncScript(getScriptURL, options) {
  options = options || {};
  return function wrapWithAsyncScript(WrappedComponent) {
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";

    var AsyncScriptLoader =
    /*#__PURE__*/
    function (_Component) {
      async_script_loader_inheritsLoose(AsyncScriptLoader, _Component);

      function AsyncScriptLoader(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.state = {};
        _this.__scriptURL = "";
        return _this;
      }

      var _proto = AsyncScriptLoader.prototype;

      _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
        if (!this.__scriptLoaderID) {
          this.__scriptLoaderID = "async-script-loader-" + idCount++;
        }

        return this.__scriptLoaderID;
      };

      _proto.setupScriptURL = function setupScriptURL() {
        this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
        return this.__scriptURL;
      };

      _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
        var _this2 = this;

        // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry
        this.setState(state, function () {
          return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
        });
      };

      _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
        var mapEntry = SCRIPT_MAP[this.__scriptURL];

        if (!mapEntry || !mapEntry.loaded) {
          throw new Error("Script is not loaded.");
        }

        for (var obsKey in mapEntry.observers) {
          mapEntry.observers[obsKey](mapEntry);
        }

        delete window[options.callbackName];
      };

      _proto.componentDidMount = function componentDidMount() {
        var _this3 = this;

        var scriptURL = this.setupScriptURL();
        var key = this.asyncScriptLoaderGetScriptLoaderID();
        var _options = options,
            globalName = _options.globalName,
            callbackName = _options.callbackName,
            scriptId = _options.scriptId; // check if global object already attached to window

        if (globalName && typeof window[globalName] !== "undefined") {
          SCRIPT_MAP[scriptURL] = {
            loaded: true,
            observers: {}
          };
        } // check if script loading already


        if (SCRIPT_MAP[scriptURL]) {
          var entry = SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"

          if (entry && (entry.loaded || entry.errored)) {
            this.asyncScriptLoaderHandleLoad(entry);
            return;
          } // if still loading then callback to observer queue


          entry.observers[key] = function (entry) {
            return _this3.asyncScriptLoaderHandleLoad(entry);
          };

          return;
        }
        /*
         * hasn't started loading
         * start the "magic"
         * setup script to load and observers
         */


        var observers = {};

        observers[key] = function (entry) {
          return _this3.asyncScriptLoaderHandleLoad(entry);
        };

        SCRIPT_MAP[scriptURL] = {
          loaded: false,
          observers: observers
        };
        var script = document.createElement("script");
        script.src = scriptURL;
        script.async = true;

        for (var attribute in options.attributes) {
          script.setAttribute(attribute, options.attributes[attribute]);
        }

        if (scriptId) {
          script.id = scriptId;
        }

        var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
          if (SCRIPT_MAP[scriptURL]) {
            var mapEntry = SCRIPT_MAP[scriptURL];
            var observersMap = mapEntry.observers;

            for (var obsKey in observersMap) {
              if (func(observersMap[obsKey])) {
                delete observersMap[obsKey];
              }
            }
          }
        };

        if (callbackName && typeof window !== "undefined") {
          window[callbackName] = function () {
            return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
          };
        }

        script.onload = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.loaded = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              if (callbackName) {
                return false;
              }

              observer(mapEntry);
              return true;
            });
          }
        };

        script.onerror = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.errored = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              observer(mapEntry);
              return true;
            });
          }
        };

        document.body.appendChild(script);
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        // Remove tag script
        var scriptURL = this.__scriptURL;

        if (options.removeOnUnmount === true) {
          var allScripts = document.getElementsByTagName("script");

          for (var i = 0; i < allScripts.length; i += 1) {
            if (allScripts[i].src.indexOf(scriptURL) > -1) {
              if (allScripts[i].parentNode) {
                allScripts[i].parentNode.removeChild(allScripts[i]);
              }
            }
          }
        } // Clean the observer entry


        var mapEntry = SCRIPT_MAP[scriptURL];

        if (mapEntry) {
          delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];

          if (options.removeOnUnmount === true) {
            delete SCRIPT_MAP[scriptURL];
          }
        }
      };

      _proto.render = function render() {
        var globalName = options.globalName; // remove asyncScriptOnLoad from childProps

        var _this$props = this.props,
            asyncScriptOnLoad = _this$props.asyncScriptOnLoad,
            forwardedRef = _this$props.forwardedRef,
            childProps = async_script_loader_objectWithoutPropertiesLoose(_this$props, ["asyncScriptOnLoad", "forwardedRef"]); // eslint-disable-line no-unused-vars


        if (globalName && typeof window !== "undefined") {
          childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
        }

        childProps.ref = forwardedRef;
        return (0,react.createElement)(WrappedComponent, childProps);
      };

      return AsyncScriptLoader;
    }(react.Component); // Note the second param "ref" provided by React.forwardRef.
    // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
    // And it can then be attached to the Component.


    var ForwardedComponent = (0,react.forwardRef)(function (props, ref) {
      return (0,react.createElement)(AsyncScriptLoader, async_script_loader_extends({}, props, {
        forwardedRef: ref
      }));
    });
    ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
    ForwardedComponent.propTypes = {
      asyncScriptOnLoad: (prop_types_default()).func
    };
    return hoist_non_react_statics_cjs_default()(ForwardedComponent, WrappedComponent);
  };
}
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/recaptcha-wrapper.js


var callbackName = "onloadcallback";
var globalName = "grecaptcha";

function getOptions() {
  return typeof window !== "undefined" && window.recaptchaOptions || {};
}

function getURL() {
  var dynamicOptions = getOptions();
  var hostname = dynamicOptions.useRecaptchaNet ? "recaptcha.net" : "www.google.com";
  return "https://" + hostname + "/recaptcha/api.js?onload=" + callbackName + "&render=explicit";
}

/* harmony default export */ var recaptcha_wrapper = (makeAsyncScript(getURL, {
  callbackName: callbackName,
  globalName: globalName
})(ReCAPTCHA));
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js


/* harmony default export */ var esm = (recaptcha_wrapper);


/***/ }),

/***/ 30266:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

/***/ }),

/***/ 54356:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"I":[{"name":"Georgi Karov","avatar":"GK","bgAvatar":"#e6f5ee","title":"Lightning fast and precise service!","content":"In my nearly a quarter of century practice, I can hardly name other than BBCIncorp corporate services company with such an instant and straight to the point response with so solid grasp on the needs of the client.","stars":5},{"name":"Siddhant Choyal","avatar":"SC","bgAvatar":"#9df5cc","title":"My #1 recommendation for company registrations","content":"Daisy will guide you through everything and reply almost instantly 100% of the times. If you\'re looking got a HK LTD company, BBCIncorp would be my #1 recommendation. They do above and beyond, it was an absolute breeze working with them.","stars":5},{"name":"Georgi Karov","avatar":"GK","bgAvatar":"#dfeef5","title":"Lightning fast and precise service!","content":"In my nearly a quarter of century practice, I can hardly name other than BBCIncorp corporate services company with such an instant and straight-to-the-point response with so solid grasp on the needs of the client.","stars":5},{"name":"Suraj","avatar":"SU","bgAvatar":"#bfd7e3","title":"Best Service !","content":"I had the pleasure of dealing with Daisy to incorporate my company, the staff at BBCincorp are professional, knowledgable and cost-effective! best service, best price and extremely competent. Would recommend it again !","stars":5},{"name":"Hasitha Dissanayake","avatar":"HD","bgAvatar":"#cdcfc8","title":"Thanks to Laura and the team for their…","content":"Thanks to Laura and the team for their professionalism and responsiveness to assist us in our company formation and bank account opening, can recommend them to anyone.","stars":5},{"name":"Michael Stoeckle","avatar":"MS","bgAvatar":"#cccfc8","title":"Great job is done by BBCIncorp","content":"The team from BBCIncorp was very fast in responding; I had an active and fruitful dialogue while the company was set up: The new venture was fully operational in less than a week which is great.","stars":5},{"name":"Jeremy","avatar":"JE","bgAvatar":"#f4fcc5","title":"Very good company","content":"Very good company. You can trust them. Frankly, this is the first time I have had to deal with a competent accountant. It changes greatly from France ^^. I had lost hope that a competent accountant existed in this world. BBCincorp gave me hope","stars":5},{"name":"Frank Duffy","avatar":"FD","bgAvatar":"#cef4f5","title":"I found BBCIncorp very easy to deal with…","content":"I found BBCIncorp very easy to deal with, they explained everything in detail from the beginning and answered any queries I had very quickly. They were efficient, pleasant to work with & I would have no problem recommending them to anyone.","stars":5},{"name":"Andrii Ch","avatar":"AC","bgAvatar":"#cef6f4","title":"Highly professional and responsive experts","content":"BBC Incorp is one of a kind international legal consultant and advisor of the highest caliber. I especially recommend working with Mrs. Linda Chen, who is a first-class legal specialist.","stars":5}]}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3105,9593,9885,8352,4090,9738,7447,9156,9774,2888,179], function() { return __webpack_exec__(6805); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);